import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TellUsButton } from "@/components/common/TellUsButton";

const HERO_CONTENT_MOTION = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { delay: 0.5, duration: 0.6 },
};

const line = {
  hidden: { y: "108%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.8, delay: 0.1 + i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

const MaskedLine = ({ children, i }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span variants={line} custom={i} initial="hidden" animate="show" className="block">
      {children}
    </motion.span>
  </span>
);

export const Hero = () => (
  <section className="relative bg-navy pt-[72px]" data-testid="hero-section">
    <div className="mx-auto max-w-7xl px-5 pb-20 pt-20 lg:px-8 lg:pb-28 lg:pt-32">
      <h1 className="font-heading text-[13vw] font-extrabold leading-[0.92] tracking-tighter text-white sm:text-7xl lg:text-8xl">
        <MaskedLine i={0}>Different Needs.</MaskedLine>
        <MaskedLine i={1}>
          <span className="text-blue-500">Deliberate</span> Solutions.
        </MaskedLine>
      </h1>

      <motion.div
        {...HERO_CONTENT_MOTION}
        className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end lg:gap-16"
      >
        <p className="max-w-2xl text-xl leading-relaxed text-slate-300">
          Success Crest Consulting works across People &amp; HR, Career, and AI &amp; Digital
          Solutions. We start with the problem in front of you and bring the right capability to
          solve it — nothing more, nothing less.
        </p>
        <div className="flex flex-wrap items-center gap-3">
          <TellUsButton size="lg" testId="hero-tell-us-cta" />
          <Link
            to="/services"
            data-testid="hero-explore-cta"
            className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-8 py-4 text-sm font-medium text-white transition-colors duration-300 hover:border-white hover:bg-white/5"
          >
            Explore Our Services
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);
